import { Action } from '@occc-app/rootRedux';

import types, { State } from './types';

import { default as offerTypes } from '../../../redux/types';

export const initialState: State = {
  category: '',
  externalId: '',
  name: '',
  offerDescription: '',
  dirty: false,
  error: null,
  errorMessages: [],
  submitting: false,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case types.GET_STARTED_UPDATE:
      return {
        ...state,
        [action.key]: action.value,
        dirty: true,
      };
    case types.REQUEST_GET_STARTED_OK:
      return {
        ...initialState,
        category: action.category,
        externalId: action.externalId,
        name: action.name,
        offerDescription: action.offerDescription,
      };
    case types.RESET_INITIAL_GET_STARTED_STATE:
      return {
        ...state,
        ...action.getStartedMetaData,
      };
    /* NOTE: GetStarted has a dedicated clear (and does not implement offerTypes.CLEAR_OFFER_COMPONENT_STATE)
       so GetStated is not blown away when Earning Mechanism type is swapped */
    case offerTypes.CLEAR_GET_STARTED_STATE:
      return initialState;
  }
  return state;
}
